import React from 'react'
import Modal from 'react-bootstrap/Modal'
import { useTranslation } from 'react-i18next'
import { modalRatingStyle } from '~/helper/const'
import useNavigationFunctions from '~/helper/navigationFunctions'
import useTutorialFunctions from '~/helper/tutorialFunctions'
import * as S from './styled'

export default function ModalTutorialAllSteps({ handleCloseModal, showModal }) {
  const { t } = useTranslation()
  const { setTutorialAsActiveAction, neverShowTheTutorialAgainForTheSponsorAction } = useTutorialFunctions()
  const { setSponsorCurrentTabAction } = useNavigationFunctions()

  const setTutorialAsActiveAndCloseModal = () => {
    setSponsorCurrentTabAction('communities')
    setTutorialAsActiveAction()
    handleCloseModal()
  }

  const handleNeverShowThisMessageAgainButton = () => {
    neverShowTheTutorialAgainForTheSponsorAction()
    handleCloseModal()
  }

  return (
    <S.ModalCustom show={showModal} onHide={handleCloseModal}>
      <S.FadingBackground>
        <S.AvatarImageContainer>
          <S.AvatarImage />
        </S.AvatarImageContainer>
      </S.FadingBackground>
      <Modal.Body style={modalRatingStyle}>
        <S.TutorialDescription>{t('sponsorFirstTutorialDescription')}</S.TutorialDescription>
        <S.TutorialDescription>{t('sponsorSecondTutorialDescription')}</S.TutorialDescription>
        <S.AvailableStepsContainer>
          <S.StepContainer>
            <S.StepTitle>{`${t('step')} 1`}</S.StepTitle>
            <S.Circle />
            <S.StepDescription>{t('sponsorStep1TutorialLabel')}</S.StepDescription>
          </S.StepContainer>
          <S.StepContainer spacing>
            <S.StepTitle>{`${t('step')} 2`}</S.StepTitle>
            <S.Circle />
            <S.StepDescription>{t('sponsorStep2TutorialLabel')}</S.StepDescription>
          </S.StepContainer>
          <S.StepContainer spacing>
            <S.StepTitle>{`${t('step')} 3`}</S.StepTitle>
            <S.Circle />
            <S.StepDescription>{t('sponsorStep3TutorialLabel')}</S.StepDescription>
          </S.StepContainer>
          <S.StepContainer spacing>
            <S.StepTitle>{`${t('step')} 4`}</S.StepTitle>
            <S.Circle />
            <S.StepDescription>{t('sponsorStep4TutorialLabel')}</S.StepDescription>
          </S.StepContainer>
        </S.AvailableStepsContainer>
        <S.NextButton onClick={() => setTutorialAsActiveAndCloseModal()}>
          <S.NextText>{t('next')}</S.NextText>
        </S.NextButton>
        <S.SkipIt onClick={handleCloseModal}>{t('tutorialSkip')}</S.SkipIt>
        <S.DontShowThisMessageAgain onClick={() => handleNeverShowThisMessageAgainButton()}>
          {t('dontShowThisMessageAgain')}
        </S.DontShowThisMessageAgain>
      </Modal.Body>
    </S.ModalCustom>
  )
}
